<template>
  <ion-page>
    <master-layout pageTitle="فاکتور فروش ضایعات">
      <ion-card>
        <ion-card-content>
          <div >
            <ion-button @click="addItemToList" color="secondary" >افزودن</ion-button>
            <AjaxForm :route="'WastageSellInvoice/Edit/'+id" >
              <div class="table-responsive">
                <table class="table">
                  <thead>
                  <tr>
                    <th>ضایعات</th>
                    <th>مقدار</th>
                    <th>فیمت واحد</th>
                    <th>جمع</th>
                    <th>حذف</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item,index) in items" :key="index">
                    <td>
                      <div>
                        <select autocomplete="off"
                                class="form-control"
                                name="a_wastage_ids[]">
                          <option :selected="item.auto_wastage_id === item2._id" v-for="(item2,index2) in wastage" :key="index2" :value="item2._id">{{item2.title}}</option>
                        </select>
                      </div>
                    </td>
                    <td>
                      <div>
                        <input type="tel" name="amount[]" class="form-control" @keyup="changeOrderItemAmount($event,index)" :value="item.amount">
                      </div>
                    </td>
                    <td>
                      <div>
                        <input type="tel" name="price[]" class="form-control" @keyup="changeOrderItemPrice($event,index)" :value="item.price">
                      </div>
                    </td>
                    <td>
                      <div>
                        <Money :number="item.total"></Money>
                      </div>
                    </td>
                    <td>
                      <ion-button @click="removeItem(index)" size="small" color="danger"><i class="far fa-times"></i></ion-button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="spaceBetween">
                <div></div>
                <div>
                  جمع :
                  <Money :number="total"></Money>
                </div>
              </div>
              <ion-button color="success" type="submit" expand="full">ویرایش</ion-button>
            </AjaxForm>
          </div>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import {IonPage} from '@ionic/vue';
// import {showSystemNoti} from "@/shared/helper";
import AjaxForm from "@/components/AjaxForm";
import Money from "@/components/Money";
import {mapActions} from "vuex";

// import {getFormData} from '@/shared/helper'

export default {
  components: {
    IonPage,
    AjaxForm,
    Money
  },
  data()
  {
    return {
      id : null,
      wastage : [],
      items : [],
      total : 0
    }
  },
  async mounted()
  {
    this.id = this.$route.params.id;
    const check = await this.getAllAutoWastage();
    if (check.ok)
      this.wastage = check.wastages;
    const check2 = await this.getWastageSellInvoice(this.id);
    if (check2.ok)
    {
      this.total = check2.invoice.total;
      this.items = check2.items;
    }

  },
  async created()
  {

  },
  methods: {
    ...mapActions("app", {
      getAllAutoWastage: 'getAllAutoWastage',
      getWastageSellInvoice: 'getWastageSellInvoice',
    }),
    addItemToList()
    {
      this.items.push({total : 0,amount : 0,price : 0})
    },
    removeItem(index)
    {
      this.items.splice(index,1);
      this.calculateItemSum();
    },
    changeOrderItemPrice : function (event,index)
    {
      this.items[index].price = (event.target.value)
      this.calculateItemSum();
    },
    changeOrderItemAmount : function (event,index)
    {
      this.items[index].amount = (event.target.value)
      this.calculateItemSum();
    },
    async calculateItemSum()
    {
      const items = this.items;
      let all_total = 0;
      for (let i = 0; i < items.length; i++)
      {
        const item = items[i];
        let total = Number(item.price) * Number(item.amount);
        if (!total)
          total = 0;
        items[i].total = total;
        all_total += total;
      }
      this.total = all_total;
    }
  },watch:{
    'items.price' : function ()
    {
      alert('ok')
    }
  }
}

</script>

<style scoped>
.h6 {
  font-weight: 900;
  font-size: 15px;
  align-self: center;
  color: #000000b3;
}
.spaceBetween
{
  display: flex;
  justify-content: space-between;
}
</style>